import { FlowController } from './flowController';
import { api, surveyController } from '../services';;
import { submitStoredSurveys } from '../services/surveySubmit';

function setFinalCodeText(code: string): void {
  const finalCodePreviewEl = document.getElementById('finalCode') as HTMLElement | null;
  const finalCodeStepEl = document.getElementById('code') as HTMLElement | null;
  const finalText = code || 'CÓDIGO NÃO DISPONÍVEL';

  if (finalCodePreviewEl) {
    finalCodePreviewEl.textContent = finalText;
  }

  if (finalCodeStepEl) {
    finalCodeStepEl.textContent = finalText;
  }
}

export function setupFinalInitialStep(flow: FlowController): void {
  const existingCode = localStorage.getItem('currentCode');

  if (existingCode) {
    setFinalCodeText(existingCode);
    flow.showStep(1);
  } else {
    flow.showStep(0);
  }
}

function showFinalFallback(flow: FlowController, hasError: boolean): void {
  const finalModalContainer = document.querySelector('.modal-container.final') as HTMLElement | null;
  const errorDiv = document.querySelector('.error-div') as HTMLElement | null;
  const retryButton = document.getElementById('retrySendButton') as HTMLButtonElement | null;

  finalModalContainer?.classList.add('hidden');

  if (hasError) {
    errorDiv?.classList.remove('hidden');

    if (retryButton) {
      retryButton.disabled = false;
    }
  } else {
    errorDiv?.classList.add('hidden');

    if (retryButton) {
      retryButton.disabled = true;
    }
  }

  flow.showStep(1);
}

async function submitFinalFlow(): Promise<string> {
  await surveyController.saveFinalSurvey();

  await submitStoredSurveys();

  let code = localStorage.getItem('currentCode');

  if (!code) {
    const result = await api.generateCode();
    code = result.code || '';

    if (code) {
      localStorage.setItem('currentCode', code);
    }
  }

  return code || '';
}

async function tryFinalFlowWithRetries(
  maxAttempts = 3
): Promise<{ success: boolean; code: string; error?: unknown }> {
  let lastError: unknown = null;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const code = await submitFinalFlow();
      return { success: true, code };
    } catch (error) {
      lastError = error;
      console.error(`Tentativa ${attempt} falhou ao enviar ratings/código`, error);
    }
  }

  return { success: false, code: '', error: lastError };
}

export async function handleFinalCodeGeneration(flow: FlowController): Promise<void> {
  const finalCorrectBtn = document.getElementById('correct') as HTMLButtonElement | null;

  if (!finalCorrectBtn) return;

  try {
    finalCorrectBtn.disabled = true;
    finalCorrectBtn.textContent = 'ENVIANDO...';
    finalCorrectBtn.classList.add('loading');

    const result = await tryFinalFlowWithRetries(3);

    if (result.success) {
      setFinalCodeText(result.code);
      showFinalFallback(flow, false);
      return;
    }

    const existingCode = localStorage.getItem('currentCode') || '';
    setFinalCodeText(existingCode);
    showFinalFallback(flow, true);
  } catch (error) {
    console.error('Erro inesperado no fluxo final:', error);

    const existingCode = localStorage.getItem('currentCode') || '';
    setFinalCodeText(existingCode);
    showFinalFallback(flow, true);
  } finally {
    finalCorrectBtn.disabled = false;
    finalCorrectBtn.textContent = 'OK';
    finalCorrectBtn.classList.remove('loading');
  }
}

export async function handleManualRetry(flow: FlowController): Promise<void> {
  const retryButton = document.getElementById('retrySendButton') as HTMLButtonElement | null;
  const errorDiv = document.querySelector('.error-div') as HTMLElement | null;
  const finalErrorMessage = document.getElementById('final_error_message') as HTMLParagraphElement;

  if (!retryButton) return;

  if (!navigator.onLine) {
    alert('Você ainda está sem internet.');
    return;
  }

  try {
    retryButton.disabled = true;
    retryButton.textContent = 'TENTANDO...';

    const code = await submitFinalFlow();
    setFinalCodeText(code);
    errorDiv?.classList.add('hidden');
    showFinalFallback(flow, false);

  } catch (error) {

    console.error('Falha na tentativa manual:', error);
    errorDiv?.classList.remove('hidden');
    finalErrorMessage.textContent = error instanceof Error ? error.message : 'Ocorreu um erro inesperado. Por favor, tente novamente.';
    retryButton.disabled = false;
    retryButton.textContent = 'TENTAR POR CONTA PRÓPRIA';

  }
}